import React,{useState, useEffect } from 'react'
import axios from 'axios'

function UserProfilebar(props) {

    const [members, setMembers] = useState([]);

    useEffect(() => {
      if (props.groupId) {
         axios.post("https://newchatapp-mn65.onrender.com/groupUsers",{id:props.groupId}).then((resp)=>{
            if(resp.data.success){
                axios.get("https://newchatapp-mn65.onrender.com/getgrpusers").then((res)=>{
                setMembers(res.data);
            })
            }
         })

       

      }
    }, [props.groupId])
    

    function handleBack() {
        document.querySelector(".userProfilebar").classList.remove("translateLeft");
    }

    function grpMembers(user){
        return(
            <div style={{userSelect:"none"}}  className="chatcard">
                <div title={user.firstname} className="groupmember userchatcard">
                    <img style={{cursor:"context-menu"}} className='chatprofile homeprofilepic' src={ user.image||"images/defaultProfile.png"} alt="" />
                    <h3 style={{marginTop:"0.5rem"}} className='selectUserH3'>{user.firstname}</h3>          
                </div>
                <hr className='hrcardGroup' />
            </div>
        )
    }

    return (
        <div className='userProfilebar'>
            <section style={{userSelect:"none"}} className='homesection'>
                <i onClick={handleBack} style={{ color: "white", fontSize: "1.25rem", padding: "1rem", cursor: "pointer" }} class="fa-solid fa-xmark"></i>
                <p style={{ fontWeight: "600", marginRight: "55%" }}>Contact Info</p>
            </section>
            <div className="myProfileBody">
                <div className="myProfileBodydiv userProfilebarimgdiv">
                    <img  draggable="false" style={{ width: "12.7rem",cursor:"pointer",userSelect:"none" }} className='myProfileBodydivPic' src={props.image?props.image:"images/defaultProfile.png" }alt="" />
                    <h3>{props.firstname}</h3>
                </div>
                 {props.groupId && members.map(grpMembers)} 
            </div>
        </div>
    )
}

export default UserProfilebar